import React, { Component } from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import './TabView.css';
import GameList from '../../GameList/index';
import TournamentList from '../../TournamentList/index';
import VideoFeed from '../../VideoFeed/index';
import withSounds from '../../withSounds';

const NavItemWithSounds = withSounds({ mouseEnterSound: true })(NavItem);

class TabView extends Component {
  constructor(props) {
    super(props);

    this.state = { activeTab: 1 };
    this.interval = null;

    this.switchTab = this.switchTab.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleStopInterval = this.handleStopInterval.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(this.switchTab, 5000);
  }

  handleSelect(key) {
    this.setState({ activeTab: key });
  }

  switchTab() {
    const { activeTab } = this.state;
    const nextTab = activeTab === 3 ? 1 : activeTab + 1;
    this.handleSelect(nextTab);
  }

  handleStopInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  componentWillUnmount() {
    this.handleStopInterval();
  }

  render() {
    const { activeTab } = this.state;

    const tabTitles = ['Play Games', 'Tournaments', 'Videos'];
    const renderNavItem = function(title, index) {
      let tab = index + 1;
      let Comp = tab === activeTab ? NavItem : NavItemWithSounds;
      return (
        <Comp key={tab} eventKey={tab} onClick={this.handleStopInterval}>
          {title}
        </Comp>
      );
    };

    return (
      <div className="tab-view">
        <Tab.Container
          id="uncontrolled-tab-view"
          className="tab-view-container"
          activeKey={activeTab}
          onSelect={this.handleSelect}
        >
          <div>
            <Nav bsStyle="tabs">{tabTitles.map(renderNavItem, this)}</Nav>
            <div className={`tab-indicator tab-${activeTab}`} />
            <Tab.Content animation mountOnEnter>
              <Tab.Pane eventKey={1}>
                <GameList onInteraction={this.handleStopInterval} />
              </Tab.Pane>
              <Tab.Pane eventKey={2}>
                <TournamentList onInteraction={this.handleStopInterval} />
              </Tab.Pane>
              <Tab.Pane eventKey={3}>
                <VideoFeed onInteraction={this.handleStopInterval} />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

export default TabView;



// WEBPACK FOOTER //
// ./src/containers/HomePage/TabView/index.js